import { useContext, useEffect, useRef } from "react";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";

import { Card } from "react-bootstrap";
import useCreateAction from "../actions/create/useCreateAction";
import { useLocation, useNavigate } from "react-router-dom";
import useListAction from "@beeldit/core/actions/list/useListAction";
import useEditAction from "@beeldit/core/actions/edit/useEditAction";
import useRemoveAction from "@beeldit/core/actions/remove/useRemoveAction";
import { getTableConfig } from "@beeldit/core/helpers/tables";

function TablePage(props: { modelConfig: any; templates?: [], modalSize?: string }) {
  const { modelConfig, templates, modalSize } = props;
  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(modelConfig, user);

  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(modelConfig, indexFunction);

  const { getFunction, actionTemplate: editActionTemplate } = useEditAction(
    modelConfig,
    indexFunction,
    modalSize
  );

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(modelConfig, indexFunction);

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  let tableConfig = getTableConfig(modelConfig.tableConfig, {
    indexFunction: indexFunction,
    actionsFunctions: [
      {
        name: "create",
        function: initializeFunction,
      },
    ],
    rowFunctions: [
      {
        name: "edit",
        function: getFunction,
      },
      {
        name: "delete",
        function: prepareRemoveFunction,
      },
    ],
  });
  setTableConfig(tableConfig);

  const location = useLocation(); // Obtener la ubicación de la URL
  const navigate = useNavigate();
  const hasOpenedFromQuery = useRef(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const isNew = urlParams.get("new");

    if (isNew === "true" && !hasOpenedFromQuery.current) {
      hasOpenedFromQuery.current = true;
      initializeFunction();

      urlParams.delete("new");
      const newSearch = urlParams.toString();
      const newPath = location.pathname + (newSearch ? `?${newSearch}` : "");
      navigate(newPath, { replace: true });
    }
  }, [location.pathname, location.search, navigate, initializeFunction]);

  return (
    <Card>
      <Card.Header className="d-flex align-items-center justify-content-between ps-3 bg-white">
        <span>{t(modelConfig.modelPluralName)}</span>
        <div>
          <BeelditTableHeaderActions
            actions={tableConfig.actions}
          ></BeelditTableHeaderActions>
        </div>
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {createActionTemplate}
        {editActionTemplate}
        {removeActionTemplate}
        {templates &&
          templates.map((template: any, index: number) => {
            return { template };
          })}
        {/* newTemplateActions */}
      </Card.Body>
    </Card>
  );
}

export default TablePage;
